import api from './api';

export const locationService = {
  // Get all active locations
  getAllActiveLocations: async () => {
    try {
      const response = await api.get('/locations/active');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to get active locations');
    }
  },

  // Get all hub locations
  getHubLocations: async () => {
    try {
      const response = await api.get('/locations/hubs');
      return response.data;
    } catch (error) {
      console.error('Error fetching hub locations:', error);
      throw error;
    }
  },

  // Get location by name
  getLocationByName: async (name) => {
    try {
      const response = await api.get(`/locations/name/${name}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching location by name:', error);
      throw error;
    }
  },

  // Get location by ID
  getLocationById: async (id) => {
    try {
      const response = await api.get(`/locations/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching location by ID:', error);
      throw error;
    }
  },

  // Create new location
  createLocation: async (locationData) => {
    try {
      const response = await api.post('/locations', locationData);
      return response.data;
    } catch (error) {
      console.error('Error creating location:', error);
      throw error;
    }
  },

  // Update location
  updateLocation: async (id, locationData) => {
    try {
      const response = await api.put(`/locations/${id}`, locationData);
      return response.data;
    } catch (error) {
      console.error('Error updating location:', error);
      throw error;
    }
  },

  // Delete location
  deleteLocation: async (id) => {
    try {
      const response = await api.delete(`/locations/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting location:', error);
      throw error;
    }
  }
};
